import { Dialog, DialogContent, Typography, IconButton  } from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import CloseIcon from '@material-ui/icons/Close'
import { useMediaQuery } from 'react-responsive'

import useStyles from './styles'

const Modal = ({ handleClose, open }: { handleClose: any, open: boolean }) => {
  const classes = useStyles()
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 598px)' })

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      maxWidth="lg"
      fullScreen={isTabletOrMobile ?? false}
    >
      <MuiDialogTitle disableTypography>
              <Typography variant="h6">Sobre o acesso</Typography>

        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>

      <DialogContent dividers>
        <Typography variant="body2">
          Esta área é de uso exclusivo dos usuários do Instituto Jô Clemente e das instituições de saúde parceiras.<br /><br />

          Hospitais, unidades básicas de saúde e demais instituições devem acessar a plataforma utilizando o e-mail e a senha fornecidos pelo Instituto Jô Clemente.<br /><br />

          Usuários internos do Instituto Jô Clemente devem utilizar o e-mail e a senha disponibilizados pelo Departamento de TI para realizar o acesso.<br /><br />

          <b>Importante: </b> Esqueceu a senha? Clique no link <b>"Esqueceu a senha?"</b> para receber, no e-mail cadastrado, um link de redefinição.
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default Modal
